export default "__VITE_ASSET__BrHFpQcS__"